import { useCallback, useMemo, useState } from 'react';
import { ButtonWatch, ButtonWrapper, CanvasWrapper, TemplateItemWrapper } from './styles';

import { Plus } from 'lucide-react';
import { useAuth } from 'modules/auth/ui/hooks/use-auth';
import useCreateModal from '../../hooks/modals/template/create';

interface IProps {}

function NewTemplate(props: IProps) {
  const [isHover, setIsHover] = useState(false);
  const { user } = useAuth();

  const { modal: createModal, open: openCreateModal } = useCreateModal();

  const isDev = process.env.REACT_APP_ENVIRONMENT !== 'production';
  const isAdmin = useMemo(() => {
    if (isDev) return true;
    if (!user) return false;
    return user.id === 20;
  }, [isDev, user]);

  const onCreateNewTemplate = useCallback(() => {
    if (!isAdmin) return;
    openCreateModal();
  }, [isAdmin, openCreateModal]);

  return (
    <TemplateItemWrapper>
      <CanvasWrapper
        onClick={onCreateNewTemplate}
        style={{ backgroundColor: 'transparent' }}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        <ButtonWrapper>
          <ButtonWatch isShow={isHover}>Добавить новый шаблон</ButtonWatch>
        </ButtonWrapper>
        <Plus opacity={0.38} size={50} />
      </CanvasWrapper>
      {createModal}
    </TemplateItemWrapper>
  );
}

export default NewTemplate;
